import { ChangeDetectorRef, Component, Input, SimpleChanges } from '@angular/core';
import { GlobalConstants } from '../../../../services/global-constants';

@Component({
  selector: 'app-services-view',
  templateUrl: './services-view.component.html',
  styleUrls: ['./services-view.component.scss']
})
export class ServicesViewComponent {
  
  layout: string = 'grid';



  @Input() filterItems!: any[]

  @Input() type!: string;

  siteUrl = GlobalConstants.staticFilesURL;

  filterText: string = '';
  notObject: any = {
    name: "notObject",
    image: "pi pi-times"
  };


  constructor( private cdr: ChangeDetectorRef ) {
  }

  @Input() items: any[] = [];
  @Input() object: any;
  notcountedItems: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['object'] && changes['object'].currentValue) {
      console.log('ngOnChanges: object changed');
      this.ngAfterViewInit();
    }
  }

  ngOnInit(): void {
    console.log('ngOnInit');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit');

    if (this.object && this.items) {
      this.filterItems = this.items;
    }

    this.filterText = '';

    //this.applyFilter()
  }


  //Image if its image or icon
  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  // Create a method to check if an item with a specific ID and 'ous' property exists
  itemHasOus(id: number, ous: number[]): boolean {
    return ous.includes(id);
  }

  applyFilter() {
    if (this.filterText) {
      // Filter items based on the filterText
      this.filterItems = this.filterItems.filter(item =>
        item.name.toLowerCase().includes(this.filterText.toLowerCase())
      );
    } else {
      // Reset the items to the original data source
      this.filterItems = this.items; // originalItems should be your unfiltered data source
    }

  }

  

  consoleThis() {
    console.log("< service view >")
  }

  applyNotObject () {
    this.filterItems = this.notcountedItems
  }

  

}
